import PropTypes from 'prop-types';
import React from 'react';
import JacketViewButton from 'app/components/shared/JacketViewButton';
import ListViewButton from 'app/components/shared/ListViewButton';
import GroupedSearchButton from 'app/components/search/GroupedSearchButton';
import cn from 'classnames';

const ViewSelector = ({ currentView, searchActions }) => {
  const toggleSearchView = view => searchActions.toggleSearchView(view);
  const groupedSearchButton = <GroupedSearchButton currentView={currentView} toggleListView={toggleSearchView} />;
  const selectorClasses = cn('cp-view-selector', 'btn-group');

  return (
    <div className={selectorClasses}>
      <ListViewButton className="hidden-sm hidden-xs" currentView={currentView} toggleListView={toggleSearchView} />
      <JacketViewButton currentView={currentView} toggleListView={toggleSearchView} />
      {groupedSearchButton}
    </div>
  );
};

ViewSelector.propTypes = {
  searchActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentView: PropTypes.string.isRequired
};

export default ViewSelector;
